export default __webpack_public_path__ + "static/media/aeroland-payment-hero-image.cf747a53.png";